var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"timeout":"2500","color":"error","top":""},model:{value:(_vm.erroReqModel),callback:function ($$v) {_vm.erroReqModel=$$v},expression:"erroReqModel"}},[_vm._v(_vm._s(_vm.msgError))])
}
var staticRenderFns = []

export { render, staticRenderFns }